<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('BasicInfo')" class="mt-6">
            <basic-info></basic-info>
          </vs-tab>
          <vs-tab :label="$t('Products')" class="mt-6">
            <products :tabIndex="1"></products>
          </vs-tab>
          <vs-tab
            :label="$t('ConfigurableProducts')"
            class="mt-6"
            v-if="$tabHasPermission('GetAllProductDiscount')"
          >
            <products :tabIndex="2"></products>
          </vs-tab>
          <vs-tab
            :label="$t('Festivals')"
            class="mt-6"
            v-if="$tabHasPermission('GetAllPromotionCategories')"
          >
            <festivals></festivals>
          </vs-tab>
          <vs-tab
            :label="$t('Discounts')"
            class="mt-6"
            v-if="$tabHasPermission('GetAllProductDiscount')"
          >
            <discounts></discounts>
          </vs-tab>
          <vs-tab
            :label="$t('DeductionAndIncrease')"
            class="mt-6"
            v-if="
              $tabHasPermission(
                'GetAllGenericProductsDeductionAndIncreaseByContract'
              )
            "
          >
            <deduction-and-increase></deduction-and-increase>
          </vs-tab>
          <vs-tab
            :label="$t('BaseSalePrice')"
            class="mt-6"
            v-if="
              $tabHasPermission(
                'CreateBaseSalePrice|GetAllBaseSalePricesByContract|GetItemsOfBaseSalePrice|GetAllHistoriesOfBaseSalePriceWithPageInfo'
              )
            "
          >
            <base-sale-price></base-sale-price>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import BasicInfo from "./BasicInfo.vue";
import Products from "./Products.vue";
import Festivals from "./Festivals/Festival.vue";
import Discounts from "./Discounts/Discount.vue";
import DeductionAndIncrease from "./DeductionAndIncrease/Index.vue";
import BaseSalePrice from "./BaseSalePrice/Index.vue";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "saleManagement_Contract_Management_Index",
  components: {
    BasicInfo,
    Products,
    Festivals,
    Discounts,
    DeductionAndIncrease,
    BaseSalePrice,
  },
};
</script>
